<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-guardianWealth">
      <div class="px-3 col-3 p-0">
        <div class="heading-guardianWealth">{{ $t("result.round") }}</div>
        <div class="text-subhead-guardianWealth">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-guardianWealth">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-guardianWealth">
          {{ this.data.count === 0
            ? this.data.bet
            : this.data.detail.summary[this.data.count].bet.amount | currencyFormatter
          }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-guardianWealth">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-guardianWealth">
          {{ this.winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-guardianWealth">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-guardianWealth">
          {{ this.balance | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-guardianWealth pt-3">
      <div class="text-games-guardianWealth">{{ "Guardian Wealth" }}</div>
      <div class="text-subgame-guardianWealth">{{ $t("guardianWealth.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 50px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin" class="fas fa-caret-left arrow-side-guardianWealth" @click="delCount()"></i>
        </div>

        <div>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(reel, index) in this.newReel[0]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[1]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[2]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth"
                    :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                      " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[3]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[4]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[5]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 9" class="icon-symbol-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!this.isEndRound" class="fas fa-caret-right arrow-side-guardianWealth" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-guardianWealth">
        <h1 v-if="isFreespin">
          FREESPIN {{ this.data.count + 1 }}/{{ this.data.detail.summary.length }}
        </h1>
        <h1 v-else>SPIN {{ this.data.count + 1 }}/{{ this.data.detail.summary.length }}</h1>
      </div>
      <div v-if="this.winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-guardianWealth">
        Feature Buy
      </div>

      <div v-if="this.winnings.length" class="col-12 justify-content-start d-flex flex-row">
        <div class="bet-box-guardianWealth p-2 px-3 justify-content-start align-items-start container">
          <div class="text-multiplier">
            <h1 class="my-1 green">Multiplier x {{ this.multiplier }}</h1>
          </div>
          <div class="bet-warpper item" v-for="(detail, index) in this.winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-guardianWealth item win-box d-flex">
                <div class="d-flex justify-content-between bet-wrapper-guardianWealth item">
                  <div class="d-flex flex-row">
                    <img class="icon-detail-guardianWealth" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_${detail.symbol}.png`)
                      " alt="" />
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 green ml-2">
                        {{
                          ` ${detail.row} ` +
                          $t("result.kind") +
                          ` x${detail.count} ${detail.count > 1 ? `ways` : `way`
                        }`
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">
                      {{ currency }} {{ detail.amount | currencyFormatter }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-guardianWealth",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      balance: 0,
      bet: 0,
      count: 0,
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      roundId: "",
      timestamp: "",
      winlose: 0,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      isEndRound: false,
      round: 1,
      pagesCount: 0,
      winnings: [],
      pages: 0,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-guardianWealth")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isEndRound = result.isEndRound;
      this.freeSpinData = result.freeSpin;
      this.freeSpinData.gambleThisRound = this.freeSpinData.gamble;
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.reels = result.reels;
      this.reelSizes = [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]];
      this.multiplier = result.multiplier;
      this.winlose = result.win;
      this.bet = result.bet;
      this.newReel = await this.mapTable(this.reels, this.reelSizes);
      this.round = this.isFreespin ? this.freeSpinData.round : result.round;
      this.pagesCount = this.isFreespin ? this.freeSpinData.remain : result.round;
      this.winnings = result.winnings;
      this.balance = result.balance;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-guardianWealth {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-guardianWealth {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-guardianWealth {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-guardianWealth {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-guardianWealth {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-guardianWealth .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-guardianWealth .bet-wrapper-guardianWealth:not(:first-child) .item {
  margin-top: 10px;
  width: 800px;
}

.bet-wrapper-guardianWealth,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-guardianWealth {
  background: #1674CC;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-guardianWealth>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-guardianWealth {
  color: #000000;
  text-align: center;
}

.content-result-guardianWealth {
  background: #112139;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-guardianWealth {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-guardianWealth {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-collect-guardianWealth {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-guardianWealth {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-guardianWealth {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-guardianWealth {
  width: 100%;
  /* padding: 5%; */
}

.gamble-normal-guardianWealth {
  width: 30%;
  height: 30%;
  /* padding: 5%; */
}

.gamble-press-guardianWealth {
  width: 30%;
  height: 30%;
  margin-top: 8px;
  /* padding: 5%; */
}

.gamble-title-guardianWealth {
  width: 60%;
  height: 60%;
  /* padding: 5%; */
}

.gamble-img-guardianWealth {
  width: 45%;
  height: 45%;
  /* padding: 5%; */
}

.bet-box-guardianWealth {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.table-guardianWealth {
  /* background: url("~@/assets/resultGame/guardianWealth/slotmachine.png") no-repeat; */
  z-index: 5;
  background-size: 763px 186px;
  /* set Bg Table HERE */
  width: 763px;
  height: 268px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -130px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-guardianWealth,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-128px, -1px);
  }

  .icon-symbol.-level1 {
    width: 128px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 128px;
    height: 230px;
  }

  .icon-symbol.-level3 {
    width: 128px;
    height: 345px;
  }

  .icon-symbol.-level4 {
    width: 128px;
    height: 459px;
  }
}

@media screen and (max-width: 1030px) {
  .table-guardianWealth {
    background-size: 760px 181px;
    width: 760px;
    height: 268px;
    transform: translate(0px, -124px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-guardianWealth {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-guardianWealth {
    width: 800px;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, -1px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 127px;
    height: 229px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 344px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 459px;
  }
}


@media screen and (max-width: 900px) {
  .table-guardianWealth {
    background-size: 747px 178px;
    width: 747px;
    height: 180px;
    transform: translate(0px, -122px);
  }

  .top-reel {
    width: 67%;
    transform: translate(124px, -1px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-124px, 0px);
  }

  .icon-symbol.-level1 {
    width: 124px;
    height: 103px;
  }

  .icon-symbol.-level2 {
    width: 124px;
    height: 220px;
  }

  .icon-symbol.-level3 {
    width: 124px;
    height: 329px;
  }

  .icon-symbol.-level4 {
    width: 124px;
    height: 437px;
  }
}

@media screen and (max-width: 870px) {
  .table-guardianWealth {
    background-size: 723px 169px;
    width: 723px;
    height: 180px;
    transform: translate(0px, -117px);
  }

  .top-reel {
    width: 67%;
    transform: translate(120px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-121px, -1px);
  }

  .icon-symbol.-level1 {
    width: 121px;
    height: 100px;
  }

  .icon-symbol.-level2 {
    width: 121px;
    height: 214px;
  }

  .icon-symbol.-level3 {
    width: 121px;
    height: 325px;
  }

  .icon-symbol.-level4 {
    width: 121px;
    height: 429px;
  }
}

@media screen and (max-width: 840px) {
  .table-guardianWealth {
    background-size: 675px 169px;
    width: 723px;
    height: 180px;
    transform: translate(0px, -117px);
  }

  .top-reel {
    width: 67%;
    transform: translate(113px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-116px, -1px);
  }

  .icon-symbol.-level1 {
    width: 116px;
    height: 93px;
  }

  .icon-symbol.-level2 {
    width: 116px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 116px;
    height: 310px;
  }

  .icon-symbol.-level4 {
    width: 116px;
    height: 415px;
  }
}

@media screen and (max-width: 800px) {
  .table-guardianWealth {
    background-size: 659px 152px;
    width: 653px;
    height: 180px;
    transform: translate(0px, -108px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, -1px);
  }

  .icon-symbol.-level1 {
    width: 111;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 198px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 298px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 400px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-109px, -1px);
  }

  .icon-symbol.-level1 {
    width: 109px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 109px;
    height: 195px;
  }

  .icon-symbol.-level3 {
    width: 109px;
    height: 290px;
  }

  .icon-symbol.-level4 {
    width: 109px;
    height: 386px;
  }
}

@media screen and (max-width: 770px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 638px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, -1px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 193px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 288px;
  }

  .icon-symbol.-level4 {
    width: 107px;
    height: 385px;
  }
}

@media screen and (max-width: 740px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 593px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(100px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-103px, -1px);
  }

  .icon-symbol.-level1 {
    width: 103px;
    height: 82px;
  }

  .icon-symbol.-level2 {
    width: 103px;
    height: 185px;
  }

  .icon-symbol.-level3 {
    width: 103px;
    height: 276px;
  }

  .icon-symbol.-level4 {
    width: 103px;
    height: 368px;
  }
}

@media screen and (max-width: 710px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 565px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-100px, 0px);
  }

  .icon-symbol.-level1 {
    width: 100px;
    height: 78px;
  }

  .icon-symbol.-level2 {
    width: 100px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 100px;
    height: 265px;
  }

  .icon-symbol.-level4 {
    width: 100px;
    height: 351px;
  }
}

@media screen and (max-width: 680px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 566px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-95px, 0px);
  }

  .icon-symbol.-level1 {
    width: 95px;
    height: 78px;
  }

  .icon-symbol.-level2 {
    width: 95px;
    height: 168px;
  }

  .icon-symbol.-level3 {
    width: 95px;
    height: 251px;
  }

  .icon-symbol.-level4 {
    width: 95px;
    height: 336px;
  }
}

@media screen and (max-width: 650px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 543px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(91px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-91px, 0px);
  }

  .icon-symbol.-level1 {
    width: 91px;
    height: 75px;
  }

  .icon-symbol.-level2 {
    width: 91px;
    height: 162px;
  }

  .icon-symbol.-level3 {
    width: 91px;
    height: 242px;
  }

  .icon-symbol.-level4 {
    width: 91px;
    height: 323px;
  }
}

@media screen and (max-width: 620px) {
  .heading-guardianWealth {
    font-size: 18px;
  }

  .table-guardianWealth {
    background-size: 516px 130px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -105px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-guardianWealth {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-guardianWealth {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(87px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-86px, 0px);
  }

  .icon-symbol.-level1 {
    width: 86px;
    height: 71px;
  }

  .icon-symbol.-level2 {
    width: 86px;
    height: 154px;
  }

  .icon-symbol.-level3 {
    width: 86px;
    height: 231px;
  }

  .icon-symbol.-level4 {
    width: 86px;
    height: 307px;
  }
}

@media screen and (max-width: 600px) {
  .table-guardianWealth {
    background-size: 498px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 150px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 223px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 297px;
  }
}

@media screen and (max-width: 570px) {
  .table-guardianWealth {
    background-size: 474px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(80px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-79px, 0px);
  }

  .icon-symbol.-level1 {
    width: 79px;
    height: 65px;
  }

  .icon-symbol.-level2 {
    width: 79px;
    height: 142px;
  }

  .icon-symbol.-level3 {
    width: 79px;
    height: 212px;
  }

  .icon-symbol.-level4 {
    width: 79px;
    height: 282px;
  }
}

@media screen and (max-width: 540px) {
  .table-guardianWealth {
    background-size: 446px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(76px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-75px, 0px);
  }

  .icon-symbol.-level1 {
    width: 75px;
    height: 62px;
  }

  .icon-symbol.-level2 {
    width: 75px;
    height: 134px;
  }

  .icon-symbol.-level3 {
    width: 75px;
    height: 200px;
  }

  .icon-symbol.-level4 {
    width: 75px;
    height: 268px;
  }
}

@media screen and (max-width: 510px) {
  .table-guardianWealth {
    background-size: 402px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(68px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-70px, 0px);
  }

  .icon-symbol.-level1 {
    width: 70px;
    height: 54px;
  }

  .icon-symbol.-level2 {
    width: 70px;
    height: 125px;
  }

  .icon-symbol.-level3 {
    width: 70px;
    height: 190px;
  }

  .icon-symbol.-level4 {
    width: 70px;
    height: 253px;
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-guardianWealth>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-guardianWealth {
    font-size: 12px;
  }

  .table-guardianWealth {
    background-size: 399px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .text-subhead-guardianWealth {
    font-size: 14px;
  }

  .bet-box-guardianWealth {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-guardianWealth {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-guardianWealth {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-guardianWealth {
    width: 45px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-guardianWealth {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(66px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-67px, 0px);
  }

  .icon-symbol.-level1 {
    width: 67px;
    height: 56px;
  }

  .icon-symbol.-level2 {
    width: 67px;
    height: 120px;
  }

  .icon-symbol.-level3 {
    width: 67px;
    height: 178px;
  }

  .icon-symbol.-level4 {
    width: 67px;
    height: 240px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-guardianWealth>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-guardianWealth {
    font-size: 12px;
  }

  .table-guardianWealth {
    background-size: 375px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .text-subhead-guardianWealth {
    font-size: 14px;
  }

  .bet-box-guardianWealth {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-guardianWealth {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-guardianWealth {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-guardianWealth {
    width: 45px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-guardianWealth {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(61px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-62px, 0px);
  }

  .icon-symbol.-level1 {
    width: 62px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 62px;
    height: 113px;
  }

  .icon-symbol.-level3 {
    width: 62px;
    height: 167px;
  }

  .icon-symbol.-level4 {
    width: 62px;
    height: 223px;
  }
}

@media screen and (max-width: 420px) {
  .table-guardianWealth {
    background-size: 350px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(59px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-58px, 0px);
  }

  .icon-symbol.-level1 {
    width: 58px;
    height: 48px;
  }

  .icon-symbol.-level2 {
    width: 58px;
    height: 105px;
  }

  .icon-symbol.-level3 {
    width: 58px;
    height: 157px;
  }

  .icon-symbol.-level4 {
    width: 58px;
    height: 208px;
  }
}

@media screen and (max-width: 390px) {
  .table-guardianWealth {
    background-size: 325px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(55px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-54px, 0px);
  }

  .icon-symbol.-level1 {
    width: 54px;
    height: 44px;
  }

  .icon-symbol.-level2 {
    width: 54px;
    height: 98px;
  }

  .icon-symbol.-level3 {
    width: 54px;
    height: 144px;
  }

  .icon-symbol.-level4 {
    width: 54px;
    height: 195px;
  }
}

@media screen and (max-width: 360px) {
  .table-guardianWealth {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(51px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-50px, 0px);
  }

  .icon-symbol.-level1 {
    width: 50px;
    height: 42px;
  }

  .icon-symbol.-level2 {
    width: 50px;
    height: 90px;
  }

  .icon-symbol.-level3 {
    width: 50px;
    height: 134px;
  }

  .icon-symbol.-level4 {
    width: 50px;
    height: 177px;
  }
}

@media screen and (max-width: 340px) {
  .table-guardianWealth {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(48px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-47px, 0px);
  }

  .icon-symbol.-level1 {
    width: 47px;
    height: 38px;
  }

  .icon-symbol.-level2 {
    width: 47px;
    height: 87px;
  }

  .icon-symbol.-level3 {
    width: 47px;
    height: 124px;
  }

  .icon-symbol.-level4 {
    width: 47px;
    height: 167px;
  }
}

@media screen and (max-width: 320px) {
  .table-guardianWealth {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }

  .top-reel {
    width: 66%;
    transform: translate(44px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-44px, 0px);
  }

  .icon-symbol.-level1 {
    width: 44px;
    height: 36px;
  }

  .icon-symbol.-level2 {
    width: 44px;
    height: 78px;
  }

  .icon-symbol.-level3 {
    width: 44px;
    height: 117px;
  }

  .icon-symbol.-level4 {
    width: 44px;
    height: 155px;
  }
}
</style>